module.exports = __webpack_public_path__ + "static/media/painting_purple.07502268.svg";